<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-menu
          ref="showDateDialog"
          v-model="showDateDialog"
          :close-on-content-click="false"
          :return-value.sync="dateSelect"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="dateSelectDisplay"
              prepend-icon="mdi-calendar"
              outlined
              v-bind="attrs"
              hide-details
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="dateSelect"
            no-title
            @change="
              $refs.showDateDialog.save(dateSelectDisplay);
              showDateDialog = false;
              getReportDaily();
            "
          />
        </v-menu>
      </v-col>
    </v-row>

    <div class="mt-5">
      <v-simple-table>
        <template #default>
          <thead>
            <tr class="bg-dark">
              <th class="bg-dark text-center text-light">
                วันที่
              </th>
              <th class="bg-dark text-center text-light">
                ยอดแทง
              </th>
              <th class="bg-dark text-center text-light">
                ยอดถูก
              </th>
              <th class="bg-dark text-center text-light">
                รายจ่ายรวม
              </th>
              <th class="bg-dark text-center text-light">
                คงเหลือ
              </th>
              <th class="bg-dark text-center text-light">
                ค่าแนะนำ
              </th>
              <th class="bg-dark text-center text-light">
                vip
              </th>
              <th class="bg-dark text-center text-light">
                bonusยิง
              </th>
              <th class="bg-dark text-center text-light">
                bonusคืน
              </th>
              <th class="bg-dark text-center text-light">
                bonusวันเกิด
              </th>
              <th class="bg-dark text-center text-light">
                โปรโมท
              </th>
              <th class="bg-dark text-center text-light">
                จำนวนผู้เล่น
              </th>
              <th class="bg-dark text-center text-light">
                ยอดเบิ้ล
              </th>
              <th class="bg-dark text-center text-light">
                ยอดตอง
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in dataResult"
              :key="item.id"
            >
              <td
                align="center"
                class="text-center text-no-wrap"
              >
                {{ item.report_date }}
              </td>
              <td
                align="center"
                class="text-success text-right"
              >
                {{ Number(item.amount_all).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{ Number(item.amount_win_all).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                class="text-danger text-right"
              >
                {{ Number(item.amount_credit_all).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                :class="
                  item.amount_total > 0
                    ? 'text-right text-success'
                    : 'text-right text-danger'
                "
              >
                {{ Number(item.amount_total).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{ Number(item.amount_aff).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{ Number(item.amount_vip).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{ Number(item.amount_bonus).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{ Number(item.amount_credit_back).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{ Number(item.amount_hbd).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{ Number(item.amount_promotion).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                class="text-info text-right"
              >
                {{ Number(item.count_user).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                class="text-info text-right"
              >
                {{ Number(item.count_double).toLocaleString("en-US") }}
              </td>
              <td
                align="center"
                class="text-info text-right"
              >
                {{ Number(item.count_triple).toLocaleString("en-US") }}
              </td>
            </tr>
            <tr>
              <td align="center">
                รวม
              </td>
              <td
                align="center"
                class="text-success text-right"
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.amount_all;
                    }, 0)
                  )
                }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.amount_win_all;
                    }, 0)
                  )
                }}
              </td>
              <td
                align="center"
                class="text-danger text-right"
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.amount_credit_all;
                    }, 0)
                  )
                }}
              </td>

              <td
                align="center"
                :class="
                  dataResult.reduce((sum, amount) => {
                    return sum + amount.amount_total;
                  }, 0) > 0
                    ? 'text-right text-success'
                    : 'text-right text-danger'
                "
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.amount_total;
                    }, 0)
                  )
                }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.amount_aff;
                    }, 0)
                  )
                }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.amount_vip;
                    }, 0)
                  )
                }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.amount_bonus;
                    }, 0)
                  )
                }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.amount_credit_back;
                    }, 0)
                  )
                }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.amount_hbd;
                    }, 0)
                  )
                }}
              </td>
              <td
                align="center"
                class="text-warning text-right"
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.amount_promotion;
                    }, 0)
                  )
                }}
              </td>
              <td
                align="center"
                class="text-info text-right"
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.count_user;
                    }, 0)
                  )
                }}
              </td>
              <td
                align="center"
                class="text-info text-right"
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.count_double;
                    }, 0)
                  )
                }}
              </td>
              <td
                align="center"
                class="text-info text-right"
              >
                {{
                  Intl.NumberFormat("en-US").format(
                    dataResult.reduce((sum, amount) => {
                      return sum + amount.count_triple;
                    }, 0)
                  )
                }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <v-dialog
      v-if="preload"
      v-model="preload"
      persistent
      width="500"
      max-width="100vw"
    >
      <v-card class="pa-md-10 mx-lg-auto">
        <v-container class="text-center">
          <v-progress-circular
            :size="100"
            :width="10"
            indeterminate
            color="primary"
          />
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment-timezone';

export default {
  name: 'ReportCreditSystemDaily',
  data: () => ({
    preload: false,
    showDateDialog: false,
    dateSelect: moment().format('YYYY-MM-DD'),
    dataResult: [],
  }),
  computed: {
    dateSelectDisplay() {
      return this.dateSelect;
    },
  },

  beforeMount() {
    this.getReportDaily();
  },
  methods: {
    getReportDaily() {
      this.preload = true;

      axios
        .get('/api/report/daily', {
          params: {
            monthly: this.dateSelect,
          },
        })
        .then((response) => {
          this.dataResult = response.data.reportAll;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.preload = false;
        });
    },
  },
};
</script>
